<template>
  <div class="mobile-header">
    <div class="search">
      <input class="search-input" type="text" placeholder="请输入关键词" />
      <div class="search-btn">
        <img src="../assets/icon_search_red.png" />
      </div>
    </div>
    <div class="logo">
      <img src="../assets/logo.png" />
    </div>
    <div class="nav">
      <div>首页</div>
      <div @click="goSubmenu">省侨联概况</div>
      <div>会务动态</div>
      <div>重点工作</div>
      <div>城市动态</div>
      <div>云南省情</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class MobileHeader extends Vue {
  goSubmenu() {
    this.$router.push({ path: "/mobile/submenu" });
  }
}
</script>

<style lang="less">
.mobile-header {
  .search {
    display: flex;
    padding: 10px;
    background: #e4141d;
    justify-content: flex-end;

    .search-input {
      padding: 8px 10px;
      font-size: 14px;
      display: block;
      width: 50%;
      background: #ffffff;
      border: none;
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
    }

    .search-btn {
      width: 50px;
      cursor: pointer;
      background: #fff;
      border: none;
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 25px;
        height: 25px;
      }
    }
  }
  .logo {
    display: flex;
    justify-content: center;
    padding: 10px;
  }
  .nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: #e4141d;
    div {
      color: #ffffff;
      flex: 0 0 33.3333%;
      text-align: center;
      font-size: 18px;
      line-height: 36px;
    }
  }
}
</style>
